export default "__VITE_ASSET__BFtNTkZv__"